import React from "react";
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';

import { HiOutlineSave } from "react-icons/hi";
import NodeCardShell from '../Components/NodeCardShell';
import { describeSavedSentence } from '../Components/nodeSummary';

const SAVE_ANSWER_NODE_COLOR = '#D89C7E';

const SaveAnswer = ({ data, isConnectable, id, selected}) => {
    useSyncNodeInternals(id, `${data.saved}~${data.first}`);

    return (
        <NodeCardShell
          icon={HiOutlineSave}
          color={SAVE_ANSWER_NODE_COLOR}
          typeName="Guardar Respuesta"
          title={data.title ?? "Guardar Respuesta"}
          summary={describeSavedSentence(data.variable)}
          trigger={data.user_response}
          error={data?.error}
          selected={selected}
          handles={
            <>
              {data.saved && (
                <Handle
                  type="target"
                  position={Position.Top}
                  isConnectable={isConnectable}
                  id={`target-${id}`}
                  style={{backgroundColor: SAVE_ANSWER_NODE_COLOR}}
                />
              )}
              {data.saved && (
                <Handle
                  type="source"
                  position={Position.Bottom}
                  id={`source-${id}`}
                  isConnectable={isConnectable}
                  style={{backgroundColor: SAVE_ANSWER_NODE_COLOR}}
                />
              )}
            </>
          }
        />
    )
}

export default React.memo(SaveAnswer);